import React from 'react';
import styled from 'styled-components';

export const CourseChaptersSlideView = styled(props => <div {...props} />)`
	scroll-snap-align: start;
	width: 100%;
	flex-shrink: 0;
	min-height: 100%;
`;
